
<div class="cookie-message" *ngIf="isShowMessage"> 
    <div class="flex-left">
      <p>Файли cookie та політика конфіденційності</p>
      <p>Вебсайт Укрпошти використовує файли cookie, які допомагають нам зробити сайт більш швидким, зручним та функціональним. Продовжуючи переглядати цей сайт, Ви погоджуєтесь на використання нами файлів cookie. <br>Дізнатися більше можна на сторінці <a href="https://www.ukrposhta.ua/ua/polityka-konfidentsiinosti">Політика конфіденційності</a>.</p>
    </div>
    <div class="flex-right">
      <input type="button" id="masseg_cookie" (click)="onAgreedCoockieButtonClick()" class="btn-blue" value="Погоджуюсь">
    </div>
</div>
